export var getFileUrl = function () {
    var _a;
    var fileUrls = {
        develop: 'https://files.burgdev.ru',
        staging: 'https://files.burgstg.ru',
        production: 'https://files.mediiia.ru',
        hseOnline: 'https://files.hsedesign.online/',
    };
    return fileUrls[(_a = process.env.REACT_APP_API_CONNECTION_MODE) !== null && _a !== void 0 ? _a : 'develop'];
};
//# sourceMappingURL=getFileUrl.js.mapexport var getFileUrl = function () {
    var _a;
    var fileUrls = {
        develop: 'https://files.burgdev.ru',
        staging: 'https://files.burgstg.ru',
        production: 'https://files.mediiia.ru',
        hseOnline: 'https://files.hsedesign.online/',
    };
    return fileUrls[(_a = process.env.REACT_APP_API_CONNECTION_MODE) !== null && _a !== void 0 ? _a : 'develop'];
};
//# sourceMappingURL=getFileUrl.js.map